import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Cuti } from 'src/app/models/cuti.t';
import { ApplicationService } from 'src/app/services/application.service';
import { CutiService } from 'src/app/services/cuti/cuti.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenStorageService } from 'src/app/services/token-storage/token-storage.service';
import { FormCutiComponent } from '../form-cuti/form-cuti.component';
import { DashboardItem } from '../../../models/dashboard-item.t';

@Component({
  selector: 'app-info-cuti',
  templateUrl: './info-cuti.component.html',
  styleUrls: ['./info-cuti.component.css']
})
export class InfoCutiComponent implements OnInit {

  isLoading = false;
  saldo: DashboardItem[] = [];

  constructor(
    public matDialogRef: MatDialogRef<InfoCutiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Cuti,
    public tokenStorageService: TokenStorageService,
    private cutiService: CutiService,
    private snackBar: MatSnackBar,
    private applicationService: ApplicationService,
    private profileService: ProfileService,
  ) { }

  ngOnInit(): void {
    this.getSaldo();
  }

  getSaldo() {
    this.isLoading = true;
    this.cutiService.saldo(this.data.userId!).subscribe((response) => {
      this.saldo = response.data;
      this.isLoading = false;
    });
  }

}
